import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SidebarFiltersOld from 'xpi-black-ui/Feature/SidebarFilters';
import SidebarFilters from '../../SidebarFilters';

import Wrapper, { WrapperAction, WrapperChildren, ClearFilterButton } from './styles';

function GenericFilter({ onFilter, onClear, filters, filterNames, children }) {
  const history = useHistory();
  const [data, setData] = useState([]);

  const hasValueFiltered = useMemo(() => data?.filter(({ options }) => !!options?.find(({ isSelected }) => isSelected))?.length > 0, [data]);

  const createFilter = useCallback(() => setData(filters), [filters]);

  const clearFilter = useCallback(() => {
    const NEW_DATA = data.map(item => ({
      ...item,
      options: item.options.map(option => ({ ...option, isSelected: false })),
    }));

    onClear(NEW_DATA);
    setData(NEW_DATA);
  }, [data]);

  const updateFilter = useCallback(dataFiltered => setData(dataFiltered), []);

  const handleOnFilter = useCallback((dataFiltered) => {
    updateFilter(dataFiltered);
    onFilter(dataFiltered);
  }, []);

  useEffect(() => {
    createFilter();
  }, [filters]);

  return (
    <Wrapper>
      <WrapperAction>
        <ClearFilterButton onClick={clearFilter} disabled={!hasValueFiltered}>Limpar Filtro</ClearFilterButton>
      </WrapperAction>

      <SidebarFilters filters={data} onFilter={handleOnFilter} filterNames={filterNames} />

      {children && (
        <WrapperChildren>
          { children }
        </WrapperChildren>
      )}
    </Wrapper>
  );
}

export default memo(GenericFilter);
